export const API_ENDPOINT = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_PROD_ENDPOINT : process.env.VUE_APP_DEV_ENDPOINT
export const bucket = process.env.VUE_APP_BUCKET_URL
export const S3_ENDPOINT = 'https://d2zajlfh6q6q8q.cloudfront.net/'
export const media = '?alt=media'
